<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar
        :title="$t('dictionary')"
        style="overflow:hidden"
      ></header-bar>

      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <div class="grid-container">
          <div class="grid-item1">
            <div class="input">
              <h1 class="heading" style="color:white">
                {{ $t("dictionary") }}
              </h1>
              <input
                type="text"
                class="inputValue word"
                :placeholder="$t('searchTerm')"
                autofocus
                v-model="searchWord"
              />
              <input
                @click="search(0)"
                type="submit"
                :value="$t('search')"
                class="button srchWord"
              />
            </div>
            <div
              class="display text-light"
              v-for="task in words"
              :key="task.id"
            >
              <h3 class="pos text-light">Монгол: {{ task.task }}</h3>
              <h3 class="pos text-light">English: {{ task.taskEn }}</h3>
              <h3 class="pos text-light">Русский: {{ task.st1 }}</h3>
              <h5 class="offensives text-light"></h5>
              <h6 class="synonym text-light"></h6>
              <hr class="b-b" />
            </div>
            <div v-show="words.length == 0 && rdy" class="text-center">
              <span class="text-light "> {{ $t("noSearchResults") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";

export default {
  components: {
    footerBar,
    headerBar,
  },
  data() {
    return {
      //searchLang: "",
      searchWord: "",
      words: [],
      rdy: false,
    };
  },
  methods: {
    search(flag) {
      if (flag == undefined) flag = 0;
      let model = null;
      if (flag == 0) {
        model = {
          isPublic: true,
          task: this.searchWord,
        };
      } else if (flag == 1) {
        model = {
          isPublic: true,
          taskEn: this.searchWord,
        };
      } else if (flag == 2) {
        model = {
          isPublic: true,
          st1: this.searchWord,
        };
      }
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 10,
          ot: 556,
          model: model,
        },
        store: this.$store,
      }).then((res) => {
        this.words = res.data.tasks;
        this.rdy = true;
        if (flag == 0 && this.words.length == 0) {
          this.search(1);
        } else if (flag == 1 && this.words.length == 0) {
          this.search(2);
        }
      });
    },
  },
};
</script>
